// extracted by mini-css-extract-plugin
export default {"events":"styles_events__A8HTx","container":"styles_container__D0Qdm"};